/**
 * Options for a read whose answer decides what a screen shows: always read it again on mount, never
 * keep it, and never read it again behind the screen. A cached answer from an earlier screen must
 * not decide anything; `isFetchedAfterMount` is what keeps it off the screen, and the first two
 * make sure the fetch happens, whatever stale time the app's client sets, and that nothing
 * lingers. A refetch when the tab gets focus would, if it failed, replace the screen the person is
 * on with an error.
 */
export const FRESH_READ = {
  refetchOnMount: 'always',
  refetchOnWindowFocus: false,
  cacheTime: 0,
} as const;
